// Usado en Docker build (src/config.js está en .gitignore).
// Las URLs se inyectan con REACT_APP_* en el build.

const normalizeSocketBaseUrl = (url, fallback) => {
    if (!url) {
        return fallback;
    }

    return url
        .replace(/^wss:\/\//i, 'https://')
        .replace(/^ws:\/\//i, 'http://')
        .replace(/\/(gw_io|gw_chat|gw_notification)\/?$/i, '')
        .replace(/\/+$/, '');
};

const apiUrl =
    process.env.REACT_APP_API_URL ||
    process.env.API_GODIWAY ||
    'https://api.godiway.com/api/';

const isLocalApi = apiUrl.includes('localhost');

const resolveChatSocketUrl = () => {
    const explicit =
        process.env.REACT_APP_CHAT_SOCKET_URL ||
        process.env.CHAT_SOCKET_URL;
    if (explicit) {
        return normalizeSocketBaseUrl(explicit, 'https://api.godiway.com');
    }

    if (isLocalApi) {
        const port =
            process.env.REACT_APP_CHAT_SRV_PORT ||
            process.env.CHAT_SRV_PORT ||
            '4000';
        return `http://localhost:${port}`;
    }

    return normalizeSocketBaseUrl(
        process.env.REACT_APP_SOCKET_URL,
        'https://api.godiway.com'
    );
};

const resolveNotificationSocketUrl = () => {
    const explicit =
        process.env.REACT_APP_NOTIFICATION_SOCKET_URL ||
        process.env.NOTIFICATION_SOCKET_URL;
    if (explicit) {
        return normalizeSocketBaseUrl(explicit, 'https://api.godiway.com');
    }

    if (isLocalApi) {
        const port =
            process.env.REACT_APP_NOTIFICATION_SRV_PORT ||
            process.env.NOTIFICATION_SRV_PORT ||
            '4004';
        return `http://localhost:${port}`;
    }

    const apiOrigin = apiUrl.replace(/\/api\/?.*$/i, '').replace(/\/+$/, '');
    return normalizeSocketBaseUrl(apiOrigin, 'https://api.godiway.com');
};

const chatSocketUrl = resolveChatSocketUrl();
const notificationSocketUrl = resolveNotificationSocketUrl();

export const config = {
    production: process.env.REACT_APP_PRODUCTION === 'true' || process.env.PRODUCTION === 'true' || false,
    jwt: {
        secret: process.env.REACT_APP_JWT_SECRET || process.env.JWT_SECRET || 'notasecret!',
    },
    api: {
        google: process.env.REACT_APP_API_KEY_GOOGLE || process.env.API_KEY_GOOGLE || '',
        godiway: apiUrl,
    },
    socket: {
        url: chatSocketUrl,
        path: process.env.REACT_APP_PATH_SOCKET || process.env.PATH_SOCKET || '/gw_io',
        https: process.env.REACT_APP_HTTPS === 'true' || process.env.HTTPS === 'true' || false,
        pingInterval: Number(process.env.PING_INTERVAL) || 10000,
        pingTimeout: Number(process.env.PING_TIMEOUT) || 60000,
        withCredentials: false,
        rejectUnauthorized: false,
        transports: ['websocket', 'polling'],
        reconnectionAttempts: 'infinity',
        reconnectionDelay: Number(process.env.RECONNECTION_DELAY) || 1000,
        reconnectionDelayMax: Number(process.env.RECONNECTION_DELAY_MAX) || 5000,
        allowUpgrades: process.env.ALLOW_UPGRADES !== 'false',
        secure: process.env.REACT_APP_SOCKET_SECURE === 'true' || (!isLocalApi && process.env.REACT_APP_SOCKET_SECURE !== 'false'),
        reconnect: true,
        log: true,
    },
    chatService: {
        url: chatSocketUrl,
        port: Number(process.env.CHAT_SRV_PORT) || 4000,
        channel: process.env.CHAT_SRV_CHANNEL || 'chat',
        path: process.env.REACT_APP_CHAT_SOCKET_PATH || process.env.CHAT_PATH_SOCKET || '/gw_chat',
    },
    notificationService: {
        url: notificationSocketUrl,
        port: Number(process.env.NOTIFICATION_SRV_PORT) || 4004,
        channel: process.env.NOTIFICATION_SRV_CHANNEL || 'notification',
        path: process.env.REACT_APP_NOTIFICATION_SOCKET_PATH || process.env.NOTIFICATION_PATH_SOCKET || '/gw_notification',
    },
    paypal: {
        clientId:
            process.env.REACT_APP_PAYPAL_CLIENT_ID ||
            process.env.PAYPAL_CLIENT_ID ||
            '',
        sandbox: process.env.REACT_APP_PAYPAL_SANDBOX === 'true',
    },
    firebase: {
        enabled: process.env.REACT_APP_FIREBASE_ENABLED === 'true',
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'godiway-350020',
    },
};
